import React from "react";
import "./index.less";
export const GuardCard = ({ image, title, subTitle, alt, content }) => {
  return (
    <div className="guard_card_container">
      <div className="container_left">
        <img src={image} alt={alt} />
      </div>
      <div className="container_right">
        <h1>{title}</h1>
        {/* <h2>{subTitle}</h2> */}
        <p dangerouslySetInnerHTML={{ __html: content }}></p>
      </div>
    </div>
  );
};
